import { useState } from "react";
import { Link } from "react-router-dom";
import { ReceiptText, Loader2 } from "lucide-react";
import { toast } from "sonner";
import { api, formatRupiah } from "@/lib/api";

const STATUS = {
  pending: ["Menunggu Bayar", "bg-amber-100 text-amber-700"],
  paid: ["Dibayar", "bg-emerald-100 text-emerald-700"],
  completed: ["Selesai", "bg-blue-100 text-blue-700"],
  cancelled: ["Dibatalkan", "bg-rose-100 text-rose-700"],
};

const OrderRow = ({ o }) => (
  <div className="flex flex-col gap-2 rounded-xl border border-slate-200 p-4 sm:flex-row sm:items-center sm:justify-between">
    <div>
      <div className="text-[11px] text-slate-500">{new Date(o.created_at).toLocaleString("id-ID")}</div>
      <div className="font-bold text-slate-800">{o.product_name} · {o.chips}</div>
      <div className="text-xs text-slate-500">ID: {o.game_id}</div>
    </div>
    <div className="flex items-center gap-3">
      <span className="font-bold text-slate-800">{formatRupiah(o.price)}</span>
      <span className={`rounded-full px-3 py-1 text-[11px] font-bold ${STATUS[o.status]?.[1]}`}>{STATUS[o.status]?.[0]}</span>
    </div>
  </div>
);

export const TransaksiSaya = () => {
  const [gameId, setGameId] = useState("");
  const [wa, setWa] = useState("");
  const [loading, setLoading] = useState(false);
  const [items, setItems] = useState(null);

  const lookup = async (e) => {
    e.preventDefault();
    if (!gameId.trim()) return toast.error("Masukkan ID Pengguna");
    setLoading(true);
    try {
      const { data } = await api.get("/orders/lookup/by-game-id", { params: { game_id: gameId.trim(), wa_number: wa.trim() || undefined } });
      setItems(data.items);
    } catch {
      toast.error("Gagal memuat transaksi");
    } finally {
      setLoading(false);
    }
  };

  return (
    <main className="kz-light-page relative z-10 min-h-[calc(100vh-60px)] px-4 pb-32 pt-8" data-testid="transaksi-page">
      <div className="mx-auto max-w-5xl">
        <h1 className="flex items-center justify-center gap-3 text-center text-3xl font-black text-[#1d4ed8] sm:text-5xl">
          <ReceiptText className="h-8 w-8 sm:h-12 sm:w-12" /> Riwayat Transaksi
        </h1>
        <p className="mt-3 text-center text-sm text-slate-500 sm:text-base">Masukkan informasi akun Anda untuk melihat riwayat transaksi</p>

        <form onSubmit={lookup} className="mt-8 rounded-3xl bg-white p-6 shadow-[0_20px_60px_-20px_rgba(15,23,42,0.25)] sm:p-8">
          <h2 className="text-lg font-black text-[#1d4ed8]">Akses Transaksi</h2>
          <p className="mt-1 text-sm text-slate-500">Masukkan informasi akun Anda untuk melihat riwayat transaksi</p>
          <div className="mt-6 grid gap-4 sm:grid-cols-2">
            <div>
              <label className="text-sm font-bold text-[#1d4ed8]">ID Pengguna</label>
              <input value={gameId} onChange={(e) => setGameId(e.target.value)} placeholder="Masukkan ID Pengguna" className="kz-light-input mt-2" data-testid="transaksi-game-id-input" />
            </div>
            <div>
              <label className="text-sm font-bold text-[#1d4ed8]">Nomor WhatsApp</label>
              <input value={wa} onChange={(e) => setWa(e.target.value)} placeholder="Masukkan nomor WhatsApp" className="kz-light-input mt-2" data-testid="transaksi-wa-input" />
            </div>
            <button type="submit" disabled={loading} className="kz-blue-btn" data-testid="transaksi-lookup-btn">
              {loading ? <Loader2 size={18} className="mx-auto animate-spin" /> : "Lihat Transaksi"}
            </button>
            <Link to="/" className="kz-outline-btn" data-testid="transaksi-back-home">← Kembali ke Beranda</Link>
          </div>
        </form>

        {items !== null ? (
          <div className="mt-6 space-y-3 rounded-3xl bg-white p-6 shadow-lg" data-testid="transaksi-list">
            {items.length === 0 ? (
              <p className="text-center text-sm text-slate-500" data-testid="no-transactions">Tidak ada transaksi ditemukan.</p>
            ) : (
              items.map((o) => <OrderRow key={o.id} o={o} />)
            )}
          </div>
        ) : null}
      </div>
    </main>
  );
};
